import React from 'react';
import { useObserver } from 'mobx-react-lite';
import { storesContext } from '../stores';

function useStores(storeSelector, dataSelector) {
  const stores = React.useContext(storesContext);
  if (!stores) {
    throw new Error('[useStores] Cannot take stores from storesContext');
  }
  const store = storeSelector(stores);
  if (!store) {
    throw new Error('[useStores] storeSelector ');
  }
  return useObserver(() => dataSelector(store));
}

export default useStores;
